module.exports = __webpack_public_path__ + "img/man-stand.a370f90f.png";